;(function ($) {
  $(() => {
    new Swiper('.js-testimonials-swiper', {
      direction: 'horizontal',
      loop: false,

      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 16,

      pagination: {
        el: '.js-testimonials-swiper-pagination',
        clickable: true,
      },

      breakpoints: {
        576: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },

        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },

        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 24,
        },

        1400: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 24,
        },
      },
    })

    if ($('.js-team-swiper').length) {
      const slidesWrapper = $('.js-team-swiper')
      const slides = slidesWrapper.find('.js-team-slide')
      const slidesCount = slides.length

      // Randomly shuffle the slides array
      for (let i = slidesCount - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1))
        slides.eq(randomIndex).before(slides.eq(i))
      }

      new Swiper('.js-team-swiper', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        centeredSlides: true,
        centeredSlidesBounds: true,
        pagination: {
          el: '.js-team-swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          576: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 24,
            centeredSlides: false,
          },

          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 24,
            centeredSlides: false,
          },

          1200: {
            slidesPerView: 5,
            spaceBetween: 24,
            centeredSlides: false,
          },

          1400: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 24,
            centeredSlides: false,
          },

          1600: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 24,
            centeredSlides: false,
          },
        },
      })
    }
  })
})(jQuery)
